/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Image, Space } from "antd";
import clsx from 'clsx';
import customStyles from "../../../../../../assets/styles/customStyles";
import { NavLink } from "react-router-dom";
import DropDown from "../../../../../../assets/images/icon_menus/Drop Down.svg";
import DropUp from "../../../../../../assets/images/icon_menus/Drop Up.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../../../../Shared/components/Icons/Date";
import ImportIcon from "../../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../../assets/images/icon_actions/Export.svg";
import { useSelector } from "react-redux";
import { FilterSelect } from "../../../../../Shared/components/CustomSelect";
import FilterIcon from "../../../../../../assets/images/icon_actions/Filter Icon.svg";
import AddIcon from "../../../../../../assets/images/icon_actions/Add Icon.svg";
import { TextField, RadioGroup, FormControlLabel, Radio, FormControl } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../../../../../Shared/components/Icons/selectedIcon";
import { checkComponentPermission, checkCRUDPermission, idNamingConversion } from '../../../../../../helpers/utilities';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { Link } from "react-router-dom";
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import usePrevious from "../../../../../Shared/components/Previous";
import SearchIcon from "../../../../../../assets/images/icon_actions/Search Icon.svg";
import FilterReset from "../../../../../../assets/images/icon_actions/FilterReset.svg";
export const QuantityTopBar = (props) => {
    const { title, handleCreate, topBarView, topBar, changeHandler,
        onImportVisible, roleManagement, loadImportExportData, handleMobileFilter, productApi } = props;
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const [picker, setPicker] = useState(false);
    const [search, setSearch] = useState('');
    const timeoutRef = useRef(null);
    const prevSearch = usePrevious(search);
    const [iconAnimation, setIconAnimation] = useState(false);
    const [, setFilterOpen] = useState(false)

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                changeHandler('search', search);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    changeHandler('search', search);
                }, 500);
            }
        }
    }, [search]);

    const handlePicker = (picker) => {
        setPicker(picker);
        if (!picker) {
            changeHandler('', 'dateFilter');
        }
    }

    const mobileFilterOpen = () => {
        if (topBar?.customerGroupId || topBar?.customerId || topBar?.productId || (topBar?.startDate && topBar?.endDate)) {
            handleMobileFilter({
                type: 'ALL',
                status: topBar?.status
            });
        } else {
            setFilterOpen(true);
        }
    }
    const classes = customStyles();

    return (
        <>
            <Row className={clsx(classes.priceTopbar)}>
                <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
                    {
                        roleManagement !== '' && !topBarView && checkComponentPermission('Customer Sales Discount', 'Action', 'Search') &&
                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                            <TextField autoComplete='one-time-code'
                                placeholder='Search'
                                type='search'
                                fullWidth
                                onChange={(e) => setSearch(e.target.value)}
                                className={classes.comInput}
                                variant={'standard'}
                                id={idNamingConversion('Search', 'salesQuantityDiscount', 'TextField')}
                                onFocus={() => setIconAnimation(true)}
                                onBlur={() => setIconAnimation(false)}
                            />
                            <Image
                                src={SearchIcon}
                                preview={false}
                            />
                        </div>
                    }
                </Col>
                <Col xxl={topBarView ? 24 : 20} xl={topBarView ? 24 : 20} lg={topBarView ? 24 : 20} md={topBarView ? 24 : 24} sm={topBarView ? 24 : 24} xs={topBarView ? 24 : 24}
                    className={clsx(classes.textAlignRight, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                    <div className={clsx(classes.vertiCalScrollOverFlow, classes.customFiltersalesQuantityDiscount)}>
                        <Space size={[20, 20]} direction="horizontal" align="center">
                            {
                                roleManagement !== '' && topBarView &&
                                (checkComponentPermission('Customer Sales Discount', 'Action', 'Customer specification Filter') ||
                                    checkComponentPermission('Customer Sales Discount', 'Action', 'Product Filter') ||
                                    checkComponentPermission('Customer Sales Discount', 'Page', 'Date Filter')) &&
                                <>
                                    <NavLink
                                        to="#"
                                        id={idNamingConversion('Filter', 'salesQuantityDiscount', 'Link')}
                                        className={clsx(classes.customLink, classes.customFilter)}
                                        onClick={() => mobileFilterOpen()}>
                                        {
                                            topBar?.customerGroupId || topBar?.customerId || topBar?.productId || (topBar?.startDate && topBar?.endDate) ?
                                                <>
                                                    <Image
                                                        src={FilterReset}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Reset Filter</span>
                                                </>
                                                : <>
                                                    <Image
                                                        src={FilterIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Filter</span>
                                                </>
                                        }
                                    </NavLink>
                                </>
                            }
                            <div className={clsx(classes.fillterDropdown, classes.customFilterNone)}>
                                {

                                    roleManagement !== '' && topBarView && checkComponentPermission('Customer Sales Discount', 'Action', 'Customer specification Filter') &&
                                    <>
                                        <FormControl
                                            className={clsx(classes.dropDownPointer, classes.customRadioButton)}
                                            variant={'standard'}
                                            fullWidth >
                                            <RadioGroup
                                                row
                                                value={topBar?.type}
                                                id={idNamingConversion('Customer specification Filter', 'salesQuantityDiscount', 'Radio')}
                                                onChange={(e) => changeHandler(e.target.value, 'type')}>
                                                <FormControlLabel value="ALL" control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="All" />
                                                <FormControlLabel value="SPECIFIC" control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="Customer Specific" />
                                                <FormControlLabel value="GROUP" control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="Group" />
                                            </RadioGroup>
                                        </FormControl>
                                        {
                                            topBar?.type !== 'ALL' && <>
                                                {
                                                    topBar?.type === 'GROUP' ?
                                                        <AutoCompleteComponent
                                                            customLabel={"All Customers Group"}
                                                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                            details={customerGroupdetails}
                                                            parentValue={customObject(customerGroupdetails, topBar?.customerGroupId)}
                                                            position={"bottom"}
                                                            id={idNamingConversion('All Customers Group', 'salesQuantityDiscount', 'DropDown')}
                                                            customClasses={classes.customFilterNone}
                                                            variant={'outlined'}
                                                            onChangeText={(data) => {
                                                                if (data === '') {
                                                                    changeHandler('', 'customerGroupId')
                                                                }
                                                            }}
                                                            onChange={(data) => {
                                                                changeHandler(data.id, 'customerGroupId')
                                                            }}
                                                        /> : <AutoCompleteComponent
                                                            customLabel={"All Customers"}
                                                            id={idNamingConversion('All Customers', 'salesQuantityDiscount', 'DropDown')}
                                                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                            details={customerDetails}
                                                            parentValue={customObject(customerDetails, topBar?.customerId)}
                                                            position={"bottom"}
                                                            customClasses={classes.customFilterNone}
                                                            variant={'outlined'}
                                                            onChangeText={(data) => {
                                                                if (data === '') {
                                                                    changeHandler('', 'customerId')
                                                                }
                                                            }}
                                                            onChange={(data) => {
                                                                changeHandler(data.id, 'customerId')
                                                            }}
                                                        />
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </div>
                            {
                                roleManagement !== '' && checkComponentPermission('Customer Sales Discount', 'Action', 'Product Filter') &&
                                <AutoCompleteComponent
                                    customLabel={"All Product"}
                                    id={idNamingConversion('All Product', 'salesQuantityDiscount', 'DropDown')}
                                    heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                    { 'key': 'productId', 'name': 'Product ID' },
                                    { 'key': 'code', 'name': 'Product Code' }]}
                                    details={myProductdetails}
                                    parentValue={customObject(myProductdetails, topBar?.productId)}
                                    customClasses={clsx(classes.customWidth172P, classes.customFilterNone)}
                                    position={"bottom"}
                                    variant={'outlined'}
                                    onChangeText={(data) => {
                                        if (data === '') {
                                            changeHandler('', 'saleItemId')
                                        }
                                    }}
                                    searchType={(s) => productApi(s)}
                                    onChange={(data) => {
                                        changeHandler(data.id, 'saleItemId')
                                    }}
                                />
                            }
                            {
                                roleManagement !== '' && checkComponentPermission('Customer Sales Discount', 'Page', 'Date Filter') &&
                                <div className={clsx(classes.dateFilterwidth, classes.width250, classes.customFilterNone)}>
                                    <Row>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <NavLink to={'#'}
                                                id={idNamingConversion('Date Filter', 'salesQuantityDiscount', 'Link')}
                                                onClick={() => handlePicker(!picker)}
                                                className={clsx(classes.textAlignLeft, classes.dateFilter, classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}>
                                                Date Filter <Image
                                                    src={picker ? DropUp : DropDown}
                                                    preview={false} />
                                            </NavLink>
                                        </Col>
                                        {
                                            picker && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <div className={clsx(classes.dateFilterdateAdjust)}>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            fullWidth
                                                            slots={{
                                                                openPickerIcon: DateIcon
                                                            }}
                                                            views={['year', 'month', 'day']}
                                                            allowKeyboardControl={false}
                                                            value={topBar?.startDate || null}
                                                            label="From Date"
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,

                                                                }
                                                            }}
                                                            format="dd/MM/yyyy"
                                                            onChange={(newValue, newError) => {
                                                                if (newError?.validationError) {
                                                                    changeHandler('', 'startDate');
                                                                } else {
                                                                    changeHandler(newValue, 'startDate');
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    id: idNamingConversion('From Date', 'salesQuantityDiscount', 'TextField'),
                                                                    autoComplete: 'one-time-code'
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            fullWidth
                                                            slots={{
                                                                openPickerIcon: DateIcon
                                                            }}
                                                            views={['year', 'month', 'day']}
                                                            allowKeyboardControl={false}
                                                            value={topBar?.endDate || null}
                                                            minDate={new Date(topBar?.startDate)}
                                                            label="To Date"
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor
                                                                }
                                                            }}
                                                            format="dd/MM/yyyy"
                                                            onChange={(newValue, newError) => {
                                                                if (newError?.validationError) {
                                                                    changeHandler('', 'endDate');
                                                                } else {
                                                                    changeHandler(newValue, 'endDate');
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    id: idNamingConversion('To Date', 'salesQuantityDiscount', 'TextField'),
                                                                    autoComplete: 'one-time-code'
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </Col>
                                        }
                                    </Row>
                                </div>
                            }
                            {
                                roleManagement !== '' && topBarView && checkComponentPermission('Customer Sales Discount', 'Action', 'Status Filter') &&
                                <FilterSelect
                                    parentClasses={clsx(classes.dateFilterwidth, classes.width125)}
                                    customClasses={clsx(classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}
                                    details={[{ slug: "", label: "All" }, { slug: "active", label: "Active" }, { slug: "inactive", label: "In-active" }]}
                                    onChange={(e) => changeHandler(e.target.value, 'status')}
                                    defaultValue={topBar?.status}
                                    heads={['slug', 'label']}
                                    id={idNamingConversion('All', 'salesQuantityDiscount', 'DropDown')}
                                />

                            }

                            {
                                roleManagement !== '' && topBarView && checkComponentPermission('Customer Sales Discount', 'Action', 'Export') &&
                                <NavLink
                                    to="#"
                                    id={idNamingConversion('Export', 'salesQuantityDiscount', 'Link')}
                                    onClick={() => loadImportExportData('Sales Quantity Discount')}
                                    className={clsx(classes.customLink)}>
                                    <Image
                                        src={ExportIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                </NavLink>
                            }
                            {
                                roleManagement !== '' && topBarView && checkComponentPermission('Customer Sales Discount', 'Action', 'Import') &&
                                <NavLink
                                    to="#"
                                    id={idNamingConversion('Import', 'salesQuantityDiscount', 'Link')}
                                    onClick={() => onImportVisible(true)}
                                    className={clsx(classes.customLink, classes.width100PCustomer)}>
                                    <Image
                                        src={ImportIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                </NavLink>
                            }
                            {
                                roleManagement !== '' && topBarView && checkCRUDPermission('Customer Sales Discount', 'create', 'Sales') && <NavLink
                                    to="#"
                                    id={idNamingConversion('Create', 'salesQuantityDiscount', 'Link')}
                                    onClick={() => handleCreate()}
                                    className={clsx(classes.customLink)}>
                                    <Image
                                        src={AddIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.textCapital)}>Create {title}</span>
                                </NavLink>
                            }
                            {
                                !topBarView &&
                                <Link id={idNamingConversion('View All Prices', 'salesQuantityDiscount', 'Link')} to={`/sales/setup/sales-price`} className={clsx(classes.color, classes.bold)}>
                                    <Image src={ViewIcon} preview={false} /> <span>View All Prices</span>
                                </Link>
                            }
                        </Space>
                    </div>
                </Col>
            </Row>

            {/* <PrimaryDrawer
                open={filterOpen}
                title={'Filter and Product Group'}
                width={"360px"}
                handleClose={() => setFilterOpen(false)}
                className={clsx(classes.closeBackGround, classes.width100MaintainPrice)}
                component={
                    <FilterProductGroup
                        customerDetails={customerDetails}
                        myProductdetails={myProductdetails}
                        handleCloseMobile={() => setFilterOpen(false)}
                        customObject={(details, id) => customObject(details, id)}
                        customerGroupdetails={customerGroupdetails}
                        handleMobileFilter={(data) => { setFilterOpen(false); handleMobileFilter(data) }}
                        roleManagement={roleManagement}
                        topBarView={topBarView}
                        topBar={topBar}

                    />
                }
            /> */}

        </>

    )
};

